<form [formGroup]="form">
  <ix-fieldset
    class="general-fields"
    [title]="'Access Control Entry' | translate"
  >
    <ix-select
      formControlName="tag"
      [label]="'Who' | translate"
      [tooltip]="tooltips.tag | translate"
      [options]="tags$"
      [required]="true"
    ></ix-select>

    <ix-combobox
      *ngIf="isUserTag"
      formControlName="user"
      [label]="'User' | translate"
      [tooltip]="tooltips.user | translate"
      [provider]="userProvider"
      [allowCustomValue]="true"
      [required]="true"
    ></ix-combobox>

    <ix-combobox
      *ngIf="isGroupTag"
      formControlName="group"
      [label]="'Group' | translate"
      [tooltip]="tooltips.group | translate"
      [provider]="groupProvider"
      [allowCustomValue]="true"
      [required]="true"
    ></ix-combobox>

    <ix-radio-group
      formControlName="type"
      inlineFieldFlex="25%"
      [label]="'ACL Type' | translate"
      [tooltip]="tooltips.type | translate"
      [required]="true"
      [options]="aclTypes$"
      [inlineFields]="true"
    ></ix-radio-group>
  </ix-fieldset>

  <div class="permissions-and-flags">
    <ix-fieldset [title]="'Permissions' | translate">
      <ix-radio-group
        formControlName="permissionType"
        [label]="'Permissions Type' | translate"
        [tooltip]="tooltips.permissionType | translate"
        [required]="true"
        [options]="permissionTypes$"
        [inlineFields]="true"
      ></ix-radio-group>
      <ix-select
        *ngIf="arePermissionsBasic"
        formControlName="basicPermission"
        [label]="'Permissions' | translate"
        [tooltip]="tooltips.basicPermission | translate"
        [required]="true"
        [options]="basicPermissions$"
      ></ix-select>
      <ix-checkbox-list
        *ngIf="!arePermissionsBasic"
        formControlName="advancedPermissions"
        [label]="'Permissions' | translate"
        [tooltip]="tooltips.advancedPermissions | translate"
        [options]="advancedPermissions$"
        [inlineFields]="true"
      ></ix-checkbox-list>
    </ix-fieldset>
    <ix-fieldset [title]="'Flags' | translate">
      <ix-radio-group
        formControlName="flagsType"
        [label]="'Flags Type' | translate"
        [tooltip]="tooltips.flagsType | translate"
        [required]="true"
        [options]="flagTypes$"
        [inlineFields]="true"
      ></ix-radio-group>
      <ix-radio-group
        *ngIf="areFlagsBasic"
        formControlName="basicFlag"
        [label]="'Flags' | translate"
        [tooltip]="tooltips.basicFlag | translate"
        [required]="true"
        [options]="basicFlags$"
        [inlineFields]="true"
      ></ix-radio-group>
      <ix-checkbox-list
        *ngIf="!areFlagsBasic"
        formControlName="advancedFlags"
        [label]="'Flags' | translate"
        [tooltip]="tooltips.advancedFlags | translate"
        [options]="advancedFlags$"
        [inlineFields]="true"
      ></ix-checkbox-list>
    </ix-fieldset>
  </div>
</form>
